import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import * as yup from "yup";
import { useFormikContext } from "formik";

import { FormGroupTitle, FormSwitchField, FormTextField } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import { defaultLimitValueValidator } from "validators/licenseLimitValidators";
import {
  UPDATE_LICENSE_TEMPLATE_LIMIT_QUERY,
  READ_LICENSE_TEMPLATE_LIMITS_NAME,
} from "graphqlQueries/licenseTemplate";

const validation = yup.object({
  value: defaultLimitValueValidator,
  enable: yup.boolean(),
});

const initialValues = (limitInfo) => ({
  id_limit: limitInfo.id,
  value: limitInfo.value,
  enable: limitInfo.enabled,
});

const fieldsWithPlaceForError = ["value"];

const DialogContent = () => {
  const { values, setFieldValue } = useFormikContext();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const newEnableValue = Boolean(values.value && values.value > 0);
    if (newEnableValue === values.enable) return;
    setFieldValue("enable", newEnableValue).then();
  }, [values.value]);

  return (
    <>
      <FormGroupTitle title="Limit information" />
      <FormTextField name="value" label="Value" type="number" />
      <FormSwitchField name="enable" label="Enabled" disabled={!values.value} />
    </>
  );
};

const UpdateLicenseTemplateLimitDialog = (props) => {
  const { limitInfo } = props;

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_LICENSE_TEMPLATE_LIMIT_QUERY}
      refetchQueries={[READ_LICENSE_TEMPLATE_LIMITS_NAME]}
      initialValues={initialValues(limitInfo)}
      validationSchema={validation}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title={`Update license template limit ${limitInfo.name}`}
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <DialogContent />
    </DialogFormWithMutation>
  );
};

UpdateLicenseTemplateLimitDialog.propTypes = {
  limitInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateLicenseTemplateLimitDialog;
